import { cn } from "@/utils/index";

const Skeleton = ({ className, ...props }: React.ComponentProps<"div">) => {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-accent animate-pulse rounded", className)}
      {...props}
    />
  );
};

export { Skeleton };
